module.exports = __webpack_public_path__ + "img/23_52.e416fb4b.png";